import { Trans } from "@lingui/react/macro";
import { Icon } from "@silversea-ssc/ui-components-react";
import React from "react";
import { useOverridePhoneNumberInABTest } from "src/inbound-ab-test-experiment/phone";
import * as styles from "./ExperimentalPhoneNumber.module.scss";
import clsx from "clsx";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { isPresent } from "src/utils/checks";

type Props = {
  className?: string;
};

const ExperimentalPhoneNumber: React.FC<Props> = ({ className }) => {
  const geolocation = useGeolocation();
  const phoneNumber = useOverridePhoneNumberInABTest();
  const { phoneDisclaimer } = geolocation;

  return (
    <div
      suppressHydrationWarning
      className={clsx(styles.phoneNumberContainer, className, {
        [styles.withDisclaimer]: isPresent(phoneDisclaimer)
      })}
    >
      <Icon
        name="circle-phone"
        padding={false}
        size="1.5x"
        ariaHidden={true}
        wrapperClassName={styles.icon}
      />

      <div className={styles.content}>
        <span>
          <Trans>Let our cruise expert assist you.</Trans>{" "}
          <a
            href={`tel:${phoneNumber}`}
            aria-label={`call ${phoneNumber}`}
            data-content-piece="phone"
            className={styles.phoneNumber}
          >
            {phoneNumber}
          </a>
        </span>
      </div>

      {phoneDisclaimer && (
        <div className={styles.phoneDisclaimer}>{phoneDisclaimer}</div>
      )}
    </div>
  );
};

export default ExperimentalPhoneNumber;
